module.exports = __webpack_public_path__ + "img/img-loading.b42fcc80.png";